/**
 * The plain download mark: an arrow onto a baseline.
 *
 * DownloadIcon (no suffix) is a tray with a bar across its top and the arrow
 * enclosed inside it -- at 16px that reads as "archive" or "inbox" rather than
 * "download". This is the stripped version, kept beside it rather than
 * replacing it because the older icon is used on eight other admin pages.
 *
 * Strokes currentColor, so it takes the colour of the control it sits in --
 * DownloadIcon hard-codes #303030 and has to be handed a `color` prop.
 */
export const DownloadIconV2 = (props) => (
  <svg fill="none" height={16} viewBox="0 0 24 24" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 3.75v11.5m0 0l-4.25-4.25M12 15.25l4.25-4.25"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
    <path d="M4.75 19.25h14.5" stroke="currentColor" strokeLinecap="round" strokeWidth={2} />
  </svg>
);
